import { getNewGoalPageRouteConfig } from '@/utils/navigationConfigs'
import storeGoalTemplate from '@/utils/templates/storeGoalTemplate'

const goToGoalCreationFromTemplate = function(orgId, teamId, goal) {
  storeGoalTemplate(goal)
  const newGoalPage = getNewGoalPageRouteConfig({
    orgId,
    query: {
      expanded: true,
      teamId,
      useTemplate: true
    }
  })
  this.$router.push(newGoalPage)
}

export default goToGoalCreationFromTemplate
